"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EncryptedObject = void 0;
/*
 Copied from portis: packages/portis-crypto/src/models/encryptedObject.ts
 */
const cipherString_1 = require("./cipherString");
class EncryptedObject {
    constructor({ key, iv, data, mac, }) {
        this.key = key;
        this.iv = iv;
        this.data = data;
        this.mac = mac;
    }
    toString() {
        return new cipherString_1.CipherString(this).encryptedString;
    }
}
exports.EncryptedObject = EncryptedObject;
//# sourceMappingURL=encryptedObject.js.map